export default "__VITE_ASSET__rDzzywOr__"